import { ICaseStudyCategories } from '../../templates/case-studies-page';
import { ICaseStudyItem } from './case-study-list-item/case-study-article-list-item';

export interface ICaseStudyListProps {
  buttonText: string;
  articles: ICaseStudyItem[];
  totalCount: number;
  caseStudyCategories?: ICaseStudyCategories;
  industryCategoryText: string;
  projectCategoryText: string;
  technologyCategoryText: string;
  countryCategoryText: string;
}

export type CaseStudyListState = {
  articlesListLength: number;
  filters: (string | undefined)[];
};

export type CaseStudyListAction = {
  type: CaseStudyListActionType;
  payload?: {
    articlesCount?: number;
    filter?: string;
    filters?: (string | undefined)[];
  };
};

export enum CaseStudyListActionType {
  SET_ARTICLES_COUNT,
  SET_FILTER,
  REMOVE_FILTER,
  CLEAR_ALL
}

export enum CategoryType {
  INDUSTRY,
  PROJECT,
  TECHNOLOGY,
  COUNTRY
}
